import { sendGAEvent } from "./ga";
import { distinct } from "../../../utils/reducers";
import { type FilterData } from "../../../CMSComponents/components/CMSFilterableTileContainer/CMSFilterableTileContainer";
import debounce from "lodash/debounce";

export const trackFilterToggle = debounce((filters: FilterData[]) => {
  if (filters.length === 0) {
    return;
  }
  const codes = distinct(filters.flatMap((filter) => (filter.tags ?? "").split(",")));
  codes.sort();
  if (filters.length > 0) {
    sendGAEvent({
      eventCategory: "Content Engagement",
      eventAction: "Filter",
      eventLabel: codes.join(","),
    });
  }
}, 10 * 1000);

export function trackVideo(videoId: string) {
  sendGAEvent({
    eventCategory: "Content Engagement",
    eventAction: "Video",
    eventLabel: videoId,
  });
}

type LoginActions = "Successful" | "Cancelled" | "Register";
export function trackLoginCall(action: LoginActions) {
  sendGAEvent({
    eventCategory: "Content Engagement",
    eventAction: "Login call - Button",
    eventLabel: action,
  });
}
export function trackLogin(action: LoginActions) {
  sendGAEvent({
    eventCategory: "Content Engagement",
    eventAction: "Login Button",
    eventLabel: action,
  });
}

export function trackRegister() {
  sendGAEvent({
    eventCategory: "Content Engagement",
    eventAction: "Register - Button",
    eventLabel: "Register for Free",
  });
}
export function trackButtonClick(url: string) {
  sendGAEvent({
    eventCategory: "Content Engagement",
    eventAction: "Teaser - Button",
    eventLabel: url,
  });
}

export function trackBannerClick(url: string) {
  sendGAEvent({
    eventCategory: "Content Engagement",
    eventAction: "Header Banner - Button",
    eventLabel: url,
  });
}
